import { Badge, Card } from "react-bootstrap";
import { DeleteButton } from "../../../components/DeleteButton/DeleteButton";
import { DisplayItem } from "../../../components/DisplayItem/DisplayItem";
import { EditButton } from "../../../components/EditButton/EditButton";
import { faFolderOpen, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { faBuilding, faCloud } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Project } from "types";
import  { useState } from 'react';

type Props = {
  project: Project;
  onClickEdit: () => void;
  onClickDelete: () => void;
  onFilterByFolder?: (folderId: string) => void;
};

export const ProjectItem = ({ project, onClickEdit, onClickDelete, onFilterByFolder }: Props) => {
  const navigate = useNavigate();
  const [isFolderHovered, setIsFolderHovered] = useState(false);

  const handleViewDocuments = () => {
    navigate(`/document-details?projectId=${project.id}`);
  };

  const handleFolderClick = () => {
    if (onFilterByFolder && project.folderId) {
      onFilterByFolder(project.folderId);
    } 
    // Optional: Add else logic, e.g., navigate to folder details?
  };

  return (
    <DisplayItem>
      <Card.Body>
        <Card.Title>{project.name}</Card.Title>
        <Card.Subtitle className="mb-2 text-white opacity-75">{project.description}</Card.Subtitle>
        <Card.Text>
          {project.officeName && (
            <Badge className="border-dark text-white p-2 opacity-100 me-2 mb-2 shadow bg-dark rounded ">
              <FontAwesomeIcon icon={faBuilding} className="me-1 text-white" />
              {project.officeName}
            </Badge>
          )}
          {project.folderName && project.folderId && (
            <Badge 
              className="border-dark text-white p-2 opacity-100 shadow bg-dark rounded"
              onClick={handleFolderClick}
              style={{
                cursor: onFilterByFolder ? 'pointer' : 'default',
                transition: 'filter 0.2s ease-in-out',
                filter: isFolderHovered ? 'brightness(1.15)' : 'none'
              }}
              title={onFilterByFolder ? `Filter by Folder: ${project.folderName}` : project.folderName}
              onMouseEnter={() => onFilterByFolder && setIsFolderHovered(true)}
              onMouseLeave={() => setIsFolderHovered(false)}
            >
              <FontAwesomeIcon icon={faFolderOpen} className="me-1 text-white" />
              {project.folderName}
            </Badge>
          )}
          {project.foreignId && (
            <Badge className="border-dark text-white p-2 opacity-100 ms-2 shadow bg-info rounded">
              <FontAwesomeIcon icon={faCloud} className="me-1" style={{ color: '#FFD700' }} />
              NCVIB-ID: {project.foreignId}
            </Badge>
          )}
        </Card.Text>
      </Card.Body>
      <Card.Footer className="pt-0">
        <EditButton onClick={onClickEdit} />
        <DeleteButton onClick={onClickDelete} />
        <Button 
          variant="primary" 
          size="sm" 
          className="ms-2 text-white" 
          onClick={handleViewDocuments}
        >
          <FontAwesomeIcon icon={faFileAlt} className="me-1" />
          Documents
        </Button>
      </Card.Footer>
    </DisplayItem>
  );
};
